// import { Format } from "./format-form-types";
// import { ReactComponent as billboardSingle } from "../../../../../../img/billboard-one.svg";
// import { ReactComponent as billboardMore } from "../../../../../../img/billboard-more.svg";
// import { ReactComponent as PosterSingle } from "../../../../../../img/poster-one.svg";
// import { ReactComponent as PosterMore } from "../../../../../../img/poster-more.svg";
// import { ReactComponent as PlaqueColorSingle } from "../../../../../../img/plaque-one-green-high.svg";
// import { ReactComponent as PlaqueSingle } from "../../../../../../img/plaque-one-black-high.svg";
// import { ReactComponent as PlaqueColorMore } from "../../../../../../img/plaque-more-green-high.svg";
// import { ReactComponent as PlaqueMore } from "../../../../../../img/plaque-more-black-high.svg";
export var FormatTypeImageOrientation;
(function (FormatTypeImageOrientation) {
    FormatTypeImageOrientation["Portrait"] = "PORTRAIT";
    FormatTypeImageOrientation["Landscape"] = "LANDSCAPE";
})(FormatTypeImageOrientation || (FormatTypeImageOrientation = {}));
// export const formats: Array<Format> = [
//   {
//     name: "Billboard",
//     size: "Minimální - 2000x1000mm",
//     formatTypes: [
//       {
//         value: "billboard_single",
//         name: "Jeden projekt",
//         ImageComponent: billboardSingle,
//         imageOrientation: FormatTypeImageOrientation.Landscape,
//       },
//       {
//         value: "billboard_more",
//         name: "Více projektů",
//         ImageComponent: billboardMore,
//         imageOrientation: FormatTypeImageOrientation.Landscape,
//       },
//     ],
//   },
//   {
//     name: "Plakát A3",
//     size: "Na výšku - 297x410 mm",
//     formatTypes: [
//       {
//         value: "poster_single",
//         name: "Jeden projekt",
//         ImageComponent: PosterSingle,
//         imageOrientation: FormatTypeImageOrientation.Portrait,
//       },
//       {
//         value: "poster_more",
//         name: "Více projektů",
//         ImageComponent: PosterMore,
//         imageOrientation: FormatTypeImageOrientation.Portrait,
//       },
//     ],
//   },
//   {
//     name: "Pamětní deska",
//     size: "Na výšku - 300x400mm",
//     formatTypes: [
//       {
//         value: "plaque_color_single",
//         name: "Barevná varianta - jeden projekt",
//         ImageComponent: PlaqueColorSingle,
//         imageOrientation: FormatTypeImageOrientation.Portrait,
//       },
//       {
//         value: "plaque_black_single",
//         name: "Černobílá varianta - jeden projekt",
//         ImageComponent: PlaqueSingle,
//         imageOrientation: FormatTypeImageOrientation.Portrait,
//       },
//       {
//         value: "plaque_color_more",
//         name: "Barevná varianta - více projektů",
//         ImageComponent: PlaqueColorMore,
//         imageOrientation: FormatTypeImageOrientation.Portrait,
//       },
//       {
//         value: "plaque_more",
//         name: "Černobílá varianta - více projektů",
//         ImageComponent: PlaqueMore,
//         imageOrientation: FormatTypeImageOrientation.Portrait,
//       },
//     ],
//   },
// ];
